/* Tea Matchmaker link tags (v5.9). Every link into the quiz gets a ?src= naming
   the door it sits behind: menu, footer, hero, or page. The quiz reads it so we
   can see which entry point each visitor used. Links that already carry ?src=
   keep theirs. Runs first, so a Swiper error below can never stop it. */
(function () {
  try {
    var doorFor = function (a) {
      if (a.closest('.shopify-section-group-header-group')) return 'menu';
      if (a.closest('.shopify-section-group-footer-group')) return 'footer';
      var section = a.closest('[id^="shopify-section-"]');
      if (section && section.id.indexOf('hero') !== -1) return 'hero';
      return 'page';
    };
    var links = document.querySelectorAll('a[href*="/pages/tea-matchmaker"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      if (/[?&]src=/.test(href)) continue;
      var hash = '';
      var cut = href.indexOf('#');
      if (cut !== -1) { hash = href.slice(cut); href = href.slice(0, cut); }
      links[i].setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + 'src=' + doorFor(links[i]) + hash);
    }
  } catch (e) { /* tagging must never break the page */ }
})();

/* v7.4: only where the carousel is on the page and Swiper loaded (Tea Gift Sets skips Swiper). */
if (window.Swiper && document.querySelector(".swiperFeaturedCollectionCarousel")) {
  new Swiper(".swiperFeaturedCollectionCarousel", {
  	slidesPerView: 2,
  	spaceBetween: 6,
  	navigation: {
  		nextEl: ".customFeaturedCC__next",
  		prevEl: ".customFeaturedCC__prev",
  	},
  	pagination: {
  		el: ".swiper-pagination",
      clickable: true
  	},
  	breakpoints: {
  		640: {
  			slidesPerView: 2,
  			spaceBetween: 5,
  		},
  		768: {
  			slidesPerView: 3,
  			spaceBetween: 5,
  		},
  		1024: {
  			slidesPerView: 5,
  			spaceBetween: 8,
  		},
  	},
  });
}
